export default __webpack_public_path__ + "static/media/frame-card-highchief.d2c9df7d.png";